
import { create } from 'zustand';

interface AnnouncementState {
  announcement: string;
  assertiveAnnouncement: string;
  announce: (message: string) => void;
  announceAssertive: (message: string) => void;
  clearAnnouncement: () => void;
}

// Simple announcement store without persist
const useAnnouncementStore = create<AnnouncementState>((set) => ({
  announcement: '',
  assertiveAnnouncement: '',
  announce: (message: string) => {
    // Clear first to ensure re-announcement of same message
    set({ announcement: '' });
    setTimeout(() => set({ announcement: message }), 50);
  },
  announceAssertive: (message: string) => {
    set({ assertiveAnnouncement: '' });
    setTimeout(() => set({ assertiveAnnouncement: message }), 50);
  },
  clearAnnouncement: () => set({ announcement: '', assertiveAnnouncement: '' }),
}));

export const useAccessibilityAnnouncements = () => {
  const store = useAnnouncementStore();
  
  return {
    announcement: store.announcement,
    assertiveAnnouncement: store.assertiveAnnouncement,
    announce: store.announce,
    announceAssertive: store.announceAssertive,
    clearAnnouncement: store.clearAnnouncement,
  };
};

// Export standalone announce functions for use outside React components
export const announce = (message: string) => {
  useAnnouncementStore.getState().announce(message);
};

export const announceAssertive = (message: string) => {
  useAnnouncementStore.getState().announceAssertive(message);
};
